<div class="container-fluid py-4" [ngBusy]="busy">

  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card border-0 shadow-sm header-card">
        <div class="card-body py-4 px-5 d-flex align-items-center justify-content-between">
          <div>
            <h4 class="text-white mb-0 fw-bold">
              <i class="fas fa-list-alt me-2"></i>
              Liens de paiement envoyés
            </h4>
            <p class="text-white-50 mb-0 mt-1 small">
              Historique de tous les liens de paiement générés
            </p>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-light btn-sm fw-bold px-3" (click)="loadRequests()">
              <i class="fas fa-sync-alt me-1 text-primary"></i> Rafraîchir
            </button>
            <a routerLink="/send-payment" class="btn btn-light fw-bold px-4">
              <i class="fas fa-paper-plane me-2 text-primary"></i>
              Nouveau lien
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats -->
  <div class="row g-3 mb-4">

    <div class="col-md-3">
      <div class="stat-card">
        <div class="stat-icon bg-primary-light">
          <i class="fas fa-paper-plane text-primary"></i>
        </div>
        <div>
          <p class="stat-label">Total envoyés</p>
          <p class="stat-value">{{ totalEnvoyes }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="stat-card">
        <div class="stat-icon bg-success-light">
          <i class="fas fa-check-circle text-success"></i>
        </div>
        <div>
          <p class="stat-label">Payés / Actifs</p>
          <p class="stat-value text-success">{{ totalPaids }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="stat-card">
        <div class="stat-icon bg-warning-light">
          <i class="fas fa-clock text-warning"></i>
        </div>
        <div>
          <p class="stat-label">Non payés / Expirés</p>
          <p class="stat-value text-warning">{{ totalExpires }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="stat-card">
        <div class="stat-icon bg-purple-light">
          <i class="fas fa-sync-alt text-purple"></i>
        </div>
        <div>
          <p class="stat-label">Abonnements actifs</p>
          <p class="stat-value text-purple">{{ totalAbonnements }}</p>
        </div>
      </div>
    </div>

  </div>

  <!-- Tableau -->
  <div class="card border-0 shadow-sm" style="border-radius: 16px;">
    <div class="card-body p-4">

      <!-- Barre outils -->
      <div class="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <h6 class="fw-bold text-dark mb-0">
          <i class="fas fa-history me-2 text-primary"></i>
          Historique des envois
          <span class="text-muted fw-normal small ms-2">({{ filtered.length }} résultats)</span>
        </h6>
        <div class="d-flex align-items-center gap-3">

          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small">Afficher</span>
            <select class="form-select form-select-sm per-page-select"
              (change)="onItemsPerPageChange(+$any($event.target).value)">
              <option value="5">5</option>
              <option value="10" selected>10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span class="text-muted small">lignes</span>
          </div>

          <div class="search-wrapper">
            <i class="fas fa-search search-icon text-muted"></i>
            <input type="text" class="form-control search-input ps-5" placeholder="Rechercher un client..."
              (input)="onSearch($any($event.target).value)">
          </div>

        </div>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-head">
            <tr>
              <th>#</th>
              <th>Client</th>
              <th>Type</th>
              <th>Montant</th>
              <th>Statut lien</th>
              <th>Statut paiement</th>
              <th>Date d'envoi</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let req of paginated; let i = index">

              <td class="text-muted small">
                {{ (currentPage - 1) * itemsPerPage + i + 1 }}
              </td>

              <td>
                <div class="d-flex align-items-center">
                  <div class="avatar-sm me-3">
                    {{ req.client.company_name?.charAt(0)?.toUpperCase() }}
                  </div>
                  <div>
                    <p class="mb-0 fw-semibold text-dark">{{ req.client.company_name }}</p>
                    <p class="mb-0 text-muted small">
                      <i class="fas fa-envelope me-1"></i>{{ req.client.email }}
                    </p>
                  </div>
                </div>
              </td>

              <td>
                <span *ngIf="req.type === 'one_shot'" class="type-badge type-oneshot">
                  <i class="fas fa-bolt me-1"></i> Unique
                </span>
                <span *ngIf="req.type === 'subscription'" class="type-badge type-sub">
                  <i class="fas fa-sync-alt me-1"></i> Abonnement
                </span>
              </td>

              <td class="fw-bold text-dark">
                {{ req.montant | number:'1.2-2' }} €
              </td>

              <!-- Statut lien -->
              <td>
                <span *ngIf="isExpired(req.expires_at) && req.statut === 'lien_envoye'"
                  class="status-badge badge-expired">
                  Expiré
                </span>
                <span *ngIf="!isExpired(req.expires_at) && req.statut === 'lien_envoye'"
                  class="status-badge badge-pending">
                  Actif
                </span>
                <span *ngIf="req.statut !== 'lien_envoye'" class="status-badge badge-used">
                  Utilisé
                </span>
              </td>

              <!-- Statut paiement -->
              <td>
                <span class="status-badge" [ngClass]="getStatutPaiement(req).class">
                  <i class="fas me-1" [ngClass]="'fa-' + getStatutPaiement(req).icon"></i>
                  {{ getStatutPaiement(req).label }}
                </span>
              </td>

              <td class="text-muted small">
                {{ req.created_at | date:'dd/MM/yyyy HH:mm' }}
              </td>

              <td class="text-muted small">
                {{ req.expires_at | date:'dd/MM/yyyy HH:mm' }}
              </td>

            </tr>

            <tr *ngIf="paginated.length === 0">
              <td colspan="8" class="text-center py-5">
                <i class="fas fa-inbox fa-3x text-muted mb-3 d-block"></i>
                <p class="text-muted">Aucun lien de paiement trouvé</p>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex align-items-center justify-content-between mt-4 flex-wrap gap-3" *ngIf="totalPages > 1">

        <p class="text-muted small mb-0">
          Affichage de <strong>{{ startIndex }}</strong> à <strong>{{ endIndex }}</strong>
          sur <strong>{{ filtered.length }}</strong> entrées
        </p>

        <nav>
          <ul class="pagination pagination-sm mb-0">

            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link page-btn" (click)="goToPage(currentPage - 1)">
                <i class="fas fa-chevron-left"></i>
              </button>
            </li>

            <li *ngIf="currentPage > 3" class="page-item">
              <button class="page-link page-btn" (click)="goToPage(1)">1</button>
            </li>
            <li *ngIf="currentPage > 3" class="page-item disabled">
              <span class="page-link">...</span>
            </li>

            <li *ngFor="let page of pages" class="page-item" [class.active]="page === currentPage"
              [hidden]="page < currentPage - 2 || page > currentPage + 2">
              <button class="page-link page-btn" (click)="goToPage(page)">
                {{ page }}
              </button>
            </li>

            <li *ngIf="currentPage < totalPages - 2" class="page-item disabled">
              <span class="page-link">...</span>
            </li>
            <li *ngIf="currentPage < totalPages - 2" class="page-item">
              <button class="page-link page-btn" (click)="goToPage(totalPages)">
                {{ totalPages }}
              </button>
            </li>

            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link page-btn" (click)="goToPage(currentPage + 1)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </li>

          </ul>
        </nav>

      </div>

    </div>
  </div>

</div>